import api from '../..'

type Id = string | number

export type DestroyManyRansack = {
  user_id_in?: number[]
  user_id_not_in?: number[]
  g?: any[]
}

export type DestroyManyOptions = {
  search?: string
  q: DestroyManyRansack
  sendReport?: boolean
}

const destroyMany = (
  course: Id,
  { search, q, sendReport }: DestroyManyOptions
) => {
  return api.delete(`administration/multiple_applications`, {
    data: {
      search,
      q,
      courseId: course,
      options: {
        sendReport,
      },
    },
  })
}

export default destroyMany
